export enum SuppliesPromotionStatus {
  Draft = "draft",
  Active = "active",
}
